jQuery(function ($) {
  const temaEnv = window?.drupalSettings?.tema;
  const baseUrl = temaEnv?.sna_accesspass_api;
  const apiToken = temaEnv?.sna_accesspass_api_token;

  $("#forgot_password").submit(function (e) {
    e.preventDefault();
    // $('#forgot_password :input').prop('disabled', true);

    const formData = $(this).serializeArray();
    const jsonData = {};

    $.each(formData, function (index, field) {
      jsonData[field.name] = field.value;
    });

    // console.log(jsonData);
    registerUser(jsonData);

    //this will remove all error message upon submit of form
    $(".inputErrorText").html();
    $(".loader").addClass("active");
  });

  function registerUser(data) {
    var settings = {
      url: baseUrl + "/forgotPassword",
      method: "POST",
      timeout: 0,
      headers: {
        Accept: "application/json",
        "Api-Token": apiToken,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      complete: function () {
        // Re-enable form fields after AJAX is complete
        $("#forgot_password :input").prop("disabled", false);
      },
      error: function (error) {
        // console.log()
        $(".loader").removeClass("active");
        const errorResponse = JSON.parse(error.responseText);
        // console.log({errorResponse})
        const errors = errorResponse.errors;
        for (const field in errors) {
          if (errors.hasOwnProperty(field)) {
            const errorMessages = errors[field];
            let message = "";
            // console.log(`${field}:`);
            errorMessages.forEach((errorMessage) => {
              console.log(`- ${errorMessage}`);
              message += errorMessage;
            });
            $(`#error_${field}`).html(message);
          }
        }
      },
    };

    $.ajax(settings).done(function (response) {
      // console.log(response);

      if (response.success) {
        $("#forgot_password").hide();
        $(".reset-success").show();
      } else {
        $("#error_email").html(response.message);
        $(".loader").removeClass("active");
      }
    });

    $(".loader").removeClass("active");
  }
});
